// O texto de uma regra na lista de ajustes e regras e na linha da EAP. O novo cronograma é a
// forma (`describeProfile`); o ajuste mês a mês (D21) nomeia a referência e o que mudou
// ("Segue Desembolso do ERP a partir de 11/2026 (+2 meses)"). Uma forma ilegível não derruba
// a tela: vira "Forma indisponível".
import { describeProfile, describeReferenceRule, isWeightedProfile } from "./profile";
import { monthDistance } from "./referenceSchedule";

const MONTH = /^\d{4}-(0[1-9]|1[0-2])$/;

export const isReferenceRule = (rule) => rule?.basis === "reference";

const competence = (month) => `${month.slice(5, 7)}/${month.slice(0, 4)}`;

export const ruleText = (rule, originName = null) => {
  try {
    // O cronograma em valor por mês (o cronograma atual ajustado ou a cópia de um cronograma
    // do ERP): o número de meses e o início.
    if (isWeightedProfile(rule?.profile)) {
      const count = rule.profile.length;
      const from = MONTH.test(String(rule.startMonth ?? "")) ? ` a partir de ${competence(rule.startMonth)}` : "";
      return `Cronograma de ${count} ${count === 1 ? "mês" : "meses"}${from}`;
    }
    if (!isReferenceRule(rule)) return describeProfile(rule?.profile);
    const from = rule.reference?.startMonth;
    const shiftMonths = MONTH.test(String(from ?? "")) && MONTH.test(String(rule.startMonth ?? ""))
      ? monthDistance(from, rule.startMonth)
      : null;
    return describeReferenceRule({
      profile: rule.profile ?? null,
      startMonth: rule.startMonth ?? null,
      originLabel: originName,
      shiftMonths,
    });
  } catch {
    return "Forma indisponível";
  }
};

/**
 * O ajuste mês a mês foi gravado sobre outra origem: o valor do alvo hoje (`coveredCents`)
 * não é o que o editor mostrou ao salvar (D21).
 */
export const referenceChangedSince = (rule) => isReferenceRule(rule)
  && Number.isSafeInteger(rule?.reference?.totalCents)
  && Number.isSafeInteger(rule?.coveredCents)
  && rule.reference.totalCents !== rule.coveredCents;
